export const KEYWORDS_MAX_GROUP_DEPTH = 3;
